import { t } from "@lingui/macro";
import {
  REACT_APP__ENVIRONMENT,
  REACT_APP__URL_STORAGE_STATIC,
  textTemplateRender,
} from "@smp/utils";
import { useSnackbar } from "notistack";
import { useCallback } from "react";

export enum EPromptKey {
  ADVISOR_ASK_AUDIENCE,
  ADVISOR_ASK_PROBLEMS,
  ADVISOR_ASK_CONTEXT,
  ADVISOR_ASK_FINAL_PROMPT,
  IMAGE_GENERATE,
  IMAGE_DESCRIBE,
  ASSISTANT_WRITE_TEXT_BY_IMAGE,
}

const isProduction = ["production", "smmplanner.io"].includes(
  REACT_APP__ENVIRONMENT,
);

const FILENAME_BASE_SET: Record<EPromptKey, string> = {
  [EPromptKey.ADVISOR_ASK_AUDIENCE]: "advisor_ask_target_audience",
  [EPromptKey.ADVISOR_ASK_PROBLEMS]: "advisor_ask_problems",
  [EPromptKey.ADVISOR_ASK_CONTEXT]: "advisor_ask_context",
  [EPromptKey.ADVISOR_ASK_FINAL_PROMPT]: "advisor_ask_final_prompt",
  [EPromptKey.IMAGE_GENERATE]: "image_generate",
  [EPromptKey.IMAGE_DESCRIBE]: "image_describe",
  [EPromptKey.ASSISTANT_WRITE_TEXT_BY_IMAGE]: "assistant_write_text_by_image",
};

export const usePromptFetcher = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useCallback(
    async (key: EPromptKey, data?: Record<string, any>) => {
      const filenameBase = FILENAME_BASE_SET[key];

      const url = `${REACT_APP__URL_STORAGE_STATIC}/prompt/${filenameBase}${
        isProduction ? "" : "_staging"
      }.txt`;

      try {
        const response = await fetch(`${url}?t=${Date.now()}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const text = await response.text();
        return textTemplateRender(text, data || {});
      } catch (error) {
        enqueueSnackbar(
          t`Something went wrong... Try your request again later`,
          {
            variant: "error",
          },
        );
        throw error;
      }
    },
    [enqueueSnackbar],
  );
};
